import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-alert-inactivity-modal',
    templateUrl: './alert-inactivity-modal.component.html',
    styleUrls: ['./alert-inactivity-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertInactivityModalComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<AlertInactivityModalComponent>
  ) { }

  public remainingTime: number = 60;

  public interval: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.remainingTime--;

      if (this.remainingTime <= 0) {
        this.close();
      }
    }, 1000);
  }

  clickConfirm() {
    clearInterval(this.interval);
    this.matDialogRef.close({ continueSession: true });
  }

  close() {
    clearInterval(this.interval);
    this.matDialogRef.close({ continueSession: false });
  }

}
